import { ReactNode } from 'react';

import { BranchDeploymentBanner } from 'new-components/BranchDeploymentBanner/BranchDeploymentBanner';
import { CancellationBanner } from 'new-components/OpAppScaffold/components/CancellationBanner';

export const OpAppBanners = ({ banners }: { banners?: ReactNode }) => {
  return (
    <div className="op-app-banners">
      <BranchDeploymentBanner />
      <CancellationBanner />
      {banners}
    </div>
  );
};
